import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalActions } from "../Components/Modal";
import { Button } from "@mui/material";
import ModalTitle from "../Components/Modal/ModalTitle";
import ModalBody from "../Components/Modal/ModalBody";
import { useTranslation } from "../context/Internationalization";

const ClubDetachConfirmationModal = ({
  open,
  onClose,
  onDetachClub,
  clubName,
}) => {
  const { t } = useTranslation();

  const handleDetach = () => {
    onDetachClub();
  };

  return (
    <Modal open={open} onClose={onClose} type={"info"}>
      <ModalTitle title={t("detach_club_modal_title")} />
      <ModalBody>
        <span>
          {`${t("detach_club_confirmation_msg1")} ${clubName?.trim("")}. ${t(
            "detach_club_confirmation_msg2"
          )}`}
        </span>
      </ModalBody>
      <ModalActions>
        <Button
          variant="outlined"
          color="secondary"
          fullWidth
          onClick={onClose}
        >
          {t("close")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleDetach}
        >
          {t("ok")}
        </Button>
      </ModalActions>
    </Modal>
  );
};

ClubDetachConfirmationModal.propTypes = {};

export default ClubDetachConfirmationModal;
